import React from 'react';
import { Box } from '@mui/material';
import { AGILE_ALLOWED_CATEGORY_COMMUNITY } from '../../../utils/constants';
import { formattedCategory } from './common';
import MySkeleton from '../../../components/Skeleton';

interface RoleTypeTagProps {
  category?: string;
  place?: string;
  loading?: boolean;
  selected?: boolean;
  onClick?: () => void;
  /** Visible text when it should differ from `category` (e.g. the org's word for the role). `category` still picks the colour. */
  label?: string;
}

const RoleTypeTag: React.FC<RoleTypeTagProps> = ({ category, place, loading, selected, onClick, label: labelProp }) => {
  const useColor =
    category === 'Student'
      ? '#2955C7'
      : category === 'Faculty & Staff'
        ? '#1AA179'
        : category === 'Mentor' || (category && AGILE_ALLOWED_CATEGORY_COMMUNITY.includes(category))
          ? '#E99940'
          : category === 'Alumni'
            ? '#C7A429'
            : category === 'Mentee' || category === 'Client'
              ? '#0071A9'
              : category === 'Admin'
                ? '#28A745'
                : '#ADB5BD';

  const borderColor = selected ? '#0071A9' : useColor;
  const textColor = selected ? '#0071A9' : useColor;
  const label = labelProp || (category ? (place === 'community' ? formattedCategory(category) : category) : 'Unknown');

  const sharedStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap' as const,
    borderRadius: '20px',
    border: `1px solid ${borderColor}`,
    padding: place === 'userTable' ? '0 8px' : '2px 12px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '14px',
    color: textColor,
    background: 'transparent',
    cursor: onClick ? 'pointer' : 'default',
    // An explicit label is shown as given, so an org word like "HR lead" keeps its casing.
    textTransform: labelProp ? ('none' as const) : ('capitalize' as const)
  };

  return loading ? (
    <MySkeleton variant="rounded" height={22} width={80} />
  ) : (
    <Box sx={sharedStyles} onClick={onClick}>
      {label}
    </Box>
  );
};

export default RoleTypeTag;
